import React from "react";
import PropTypes from "prop-types";
import { Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell } from "@sainsburys-tech/fable";
import moment from "moment";

const AlertWorkOrderList = props => {
  if (props.alertWorkOrders.length === 0) {
    return (
      <React.Fragment>
        <h5>There are no work orders at this time.</h5>
        <span>
          Add work orders from Verisae to stay up to date with what’s happening
        </span>
      </React.Fragment>
    );
  }
  return (
    <Table isStriped={true} isResponsive={true} respondAt="sm">
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Work Order Number</TableHeaderCell>
          <TableHeaderCell>Added By</TableHeaderCell>
          <TableHeaderCell>Description</TableHeaderCell>
          <TableHeaderCell>Date Added</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {props.alertWorkOrders.map((workOrder, index) => (
          <TableRow key={index}>
            <TableCell>{workOrder.workOrderNumber}</TableCell>
            <TableCell>{workOrder.addedBy}</TableCell>
            <TableCell className="cb-c-workOrderDescription">{workOrder.description}</TableCell>
            <TableCell>{moment(workOrder.addedDate).format("DD/MM/YY")}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

AlertWorkOrderList.propTypes = {
  alertWorkOrders: PropTypes.array
};

export default AlertWorkOrderList;
